import { combineReducers } from 'redux';

import recoveryRadarDataReducer from './RecoveryRadarDataReducer';
import recoveryRadarUiReducer from './RecoveryRadarUIReducer';

export default combineReducers({
  data: recoveryRadarDataReducer,
  ui: recoveryRadarUiReducer,
});
